import { useState, useEffect, useMemo } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../firebase";

export function useChampiList() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const champiRef = ref(database, "/");

    const unsubscribe = onValue(champiRef, (snapshot) => {
      const firebaseData = snapshot.val();

      if (firebaseData) {
        const formattedData = Object.keys(firebaseData).map(key => ({
          id: key,
          ...firebaseData[key]
        }));
        setData(formattedData);
      } else {
        setData([]);
      }
    });

    return () => unsubscribe();
  }, []);

  const champiList = useMemo(() =>
    data.map(item => ({
      ...item,
      cover: `${process.env.PUBLIC_URL}/images_mycoV2/${item.id}_${item.genre}_${item.espece}.jpg`
    }))
  , [data]);

  return champiList;
}